import React from 'react';
import { Tag } from 'antd';
import moment from 'moment';

const renderDate = (val) => <Tag color="green">{moment(val).format('MMM Do YYYY')}</Tag>;
// The count is the number of replies. It used to be rendered as `val - 1`,
// which suggests the relational version counted the ticket itself as one;
// it now reads -1 for a ticket nobody has answered.
const renderReply = (count) => <Tag color="orange">{count ?? 0}</Tag>;
const renderName = (user) => <span>{user ? `${user.firstName} ${user.lastName}` : '—'}</span>;

export default [
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: renderDate,
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
  },
  {
    title: 'Replies',
    dataIndex: 'replyCount',
    key: 'replyCount',
    render: renderReply,
  },
  {
    title: 'Name',
    dataIndex: 'user',
    render: renderName,
    ellipsis: true,
  },
];
